export default __webpack_public_path__ + "static/media/ptx1.1cb007ee.jpg";